import React from "react";
import { Link } from "react-router-dom";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="py-32 text-center" data-testid="error-boundary">
          <h2 className="text-2xl font-display text-primary mb-2">Something went wrong</h2>
          <p className="text-muted-foreground mb-6">We're sorry — this page encountered an error.</p>
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() => this.setState({ hasError: false })}
              className="border border-border px-6 py-3 text-sm hover:bg-secondary"
            >
              Try Again
            </button>
            <Link to="/shop" className="bg-primary text-primary-foreground px-6 py-3 text-sm">
              Browse Products
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
